import { Component, inject } from '@angular/core';
import { DestinationIncoTermService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DestinationIncoTermCreateDto,
  DestinationIncoTermDto,
  DestinationIncoTermExcelDownloadDto,
  DestinationIncoTermUpdateDto,
} from '../proxy/general/dtos/destination-inco-term';
import { DESTINATIONINCOTERM_CONFIG, DESTINATIONINCOTERM_FIELDS } from './destination-inco-term.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-destination-inco-term',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DestinationIncoTermService, ConfirmationService],
  templateUrl: './destination-inco-term.html',
  styleUrl: './destination-inco-term.scss',
})
export class DestinationIncoTerm extends BaseCrudComponent<
  DestinationIncoTermDto,
  DestinationIncoTermCreateDto,
  DestinationIncoTermUpdateDto,
  DestinationIncoTermExcelDownloadDto
> {
  service = inject(DestinationIncoTermService);
  config = DESTINATIONINCOTERM_CONFIG;
  fields = DESTINATIONINCOTERM_FIELDS;

  protected prepareUpdateDto(data: any, selected: DestinationIncoTermDto): DestinationIncoTermUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DestinationIncoTerm';
  }
}
